import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../_services/auth.service';
import { AppComponent } from 'src/app/app.component';
import { NavService } from 'src/app/_services/nav.service';
import { Company } from './../../../../models/company.model';
import { CompanyService } from 'src/app/_services/company.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PopupCreateCompanyComponent } from './create-company-popup.component';
import { ToastrService } from 'src/app/_services/toastr.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'compañias',
  templateUrl: './compañias.component.html',
  styleUrls: ['./compañias.component.css'],
})
export class CompañiasComponent implements OnInit {
  COMPANIES: Company[] = [];

  page = 1;
  pageSize = 8;
  collectionSize = this.COMPANIES.length;
  companies: Company[];
  protected ngbModalRef: NgbModalRef;

  currentSearch: string = '';

  // tslint:disable-next-line: max-line-length
  constructor(
    private authService: AuthService,
    private appComponent: AppComponent,
    private navService: NavService,
    private companyService: CompanyService,
    private modalService: NgbModal,
    private toastrService: ToastrService,
    private translateService: TranslateService
  ) {
    Window['appuser'] = this;
  }

  ngOnInit() {
    this.appComponent.setTitle('Companies');
    /*
    this.companyService.saveCompany(2, {name: 'xd', logo: 'xd'}).subscribe(res => {
      window.console.log(res)
    })
    */
    this.refreshCompanies();

    this.selectedNavItem({
      parent: 'menu.administration.administration',
      child: 'menu.administration.companies',
      description: 'pageDescriptions.companies',
    });
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }

  getImgPath(path) {
    return path.match(/images\/(.*)/)[0];
  }

  refreshCompanies() {
    this.companyService
      .getAllCompanies(this.page, this.pageSize, this.currentSearch)
      .subscribe((res) => {
        this.companies = res.body['results'];
        this.collectionSize = res.body['total'];
      });
  }

  getByCompanyCount(id) {
    this.companyService.getByCompanyCount(id).subscribe((res) => {
      window.console.log(res);
    });
  }

  setSearch(e) {
    this.refreshCompanies();
  }

  createCompany() {
    window.console.log('a');
    this.ngbModalRef = this.modalService.open(PopupCreateCompanyComponent, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-holder',
      size: 'lg',
    });
    this.ngbModalRef.result.then(
      (result) => {
        this.companyService.createCompany(result).subscribe(
          (res) => {
            this.toastrService.success(
              this.translateService.instant('alert.successEdit')
            );
          },
          (err) => {
            this.toastrService.error(
              this.translateService.instant('alert.error')
            );
          }
        );
      },
      (err) => {
        window.console.log('err');
      }
    );
  }
}
